/******************************************************************************************
 * Javascript methods for the Home page
 ******************************************************************************************/

import { TaxInfo } from './_Shared.js';

TaxInfo.Home = {

    Init: function () {
    }
}
